'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _OidcManager = require('./OidcManager');

var _OidcManager2 = _interopRequireDefault(_OidcManager);

var _OidcService = require('../../services/OidcService');

var _ModuleReducer = require('../../components/module/ModuleReducer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    oidcRedirecting: (0, _ModuleReducer.getOidcRedirecting)(state.module), // render loading component if redirecting
    isRedirectUri: (0, _OidcService.isRedirectUri)(), // render callback component if currently in redirect uri
    oidcError: (0, _ModuleReducer.getOidcError)(state.module), // render error component if error
    hasUser: (0, _OidcService.getUser)(state.oidc) ? true : false // render application if logged in
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_OidcManager2.default);


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/oidc/OidcManagerContainer.js
// module id = 753
// module chunks = 10